import React from 'react';
import { Modal } from 'antd';
import { useDispatch } from 'react-redux';
import { delete_user_contact_action } from '../_redux/action';

const ContactDeleteModal = ({ deleteContact, deleteModalOpen, handleDeleteModalOpen }) => {
  const dispatch = useDispatch();

  const onDeleteContactConfirm = async () => {
    if (deleteContact?._id) {
      await dispatch(delete_user_contact_action(deleteContact._id));
    }
    handleDeleteModalOpen(null);
  };

  return (
    <Modal
      title={`Are you sure you want to delete ${deleteContact?.name}?`}
      open={deleteModalOpen}
      onOk={onDeleteContactConfirm}
      onCancel={() => handleDeleteModalOpen(null)}
      okText="Delete"
      cancelText="Cancel"
      centered
    ></Modal>
  );
};

export default ContactDeleteModal;
